import { render, staticRenderFns } from "./UserInvitees.vue?vue&type=template&id=2e205bd7&scoped=true"
import script from "./UserInvitees.vue?vue&type=script&lang=js"
export * from "./UserInvitees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e205bd7",
  null
  
)

export default component.exports